export const OMNICHANNEL_REQUEST_SERVICE_APPLET_ID = "omnichannel-applet-request-service";
// event which is sent by Omnichannel Applet when modal is opened/closed
export const OMNICHANNEL_APPLET_MODAL_EVENT_NAME = "omnichannel-modal";